// src/components/admin/ServiceForm.js
import React, { useState } from 'react';

const ServiceForm = ({ user = {}, initialData = {}, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    prefix: '',
    tenant_id: user?.tenant_id,
    ...initialData
  });

  const isEditMode = !!initialData.id;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData, isEditMode);
  };

  return (
    <form onSubmit={handleSubmit} className="admin-form">
      <div className="admin-form-group">
        <label>Service Name</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} required />
      </div>
      <div className="admin-form-group">
        <label>Prefix (e.g., W for Withdrawal, C for Cashier, DP for Deposit)</label>
        <label>For MM Only 1 letter Allowed. (e.g., W for Withdrawal, D for Deposit)</label>
        <input type="text" name="prefix" value={formData.prefix} onChange={handleChange} maxLength="2" /> {/* Max 2 chars for prefix */}
      </div>

      <div className="admin-form-actions">
        <button type="submit" className="admin-button submit">{isEditMode ? 'Update Service' : 'Add Service'}</button>
        <button type="button" onClick={onCancel} className="admin-button cancel">Cancel</button>
      </div>
    </form>
  );
};

export default ServiceForm;